import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'BlackKiteAI - AI-Powered Interview Preparation & Practice Tool',
  description = 'Master your interview answers with AI-powered coaching. BlackKiteAI helps you prepare compelling, resume-specific answers to any interview question. Practice technical and behavioral questions before your big day.',
  keywords = 'interview preparation, interview practice, AI interview coach, interview training, mock interview, technical interview prep, behavioral interview prep, resume-based coaching, job interview preparation',
  canonical = 'https://www.blackkiteai.com/',
  ogImage = 'https://www.blackkiteai.com/bkai_logo.jpeg',
  ogType = 'website'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={ogType} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
